import _regeneratorRuntime from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/workspace/smt-cloud/smt-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import router from './router';
import store from './store';
import { Message, MessageBox } from 'element-ui';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import { getAccessToken } from './utils/auth';
import { openPayment } from './utils/index';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/payReturn', '/logisticsTypeList']; // no redirect whitelist
// eslint-disable-next-line space-before-function-paren

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var hasToken, userInfo, shops, _userInfo;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            NProgress.start(); // set page title

            document.title = '欢迎使用' + process.env.VUE_APP_NAME + '系统';
            hasToken = getAccessToken();

            if (!hasToken) {
              _context.next = 52;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 9;
              break;
            }

            // if is logged in, redirect to the home page
            next({
              path: '/'
            });
            NProgress.done();
            _context.next = 50;
            break;

          case 9:
            userInfo = store.getters.user;
            shops = store.getters.shops;

            if (!(!shops || shops.length === 0)) {
              _context.next = 25;
              break;
            }

            _context.prev = 12;
            _context.next = 15;
            return store.dispatch('user/getShopList');

          case 15:
            shops = _context.sent;
            _context.next = 25;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](12);
            _context.next = 22;
            return store.dispatch('user/resetToken');

          case 22:
            Message.error(_context.t0 || 'Has Error');
            next("/login?redirect=".concat(to.path));
            NProgress.done();

          case 25:
            if (!userInfo) {
              _context.next = 29;
              break;
            }

            if (shops && shops.length > 0 || to.path === '/profile/index') {
              next();
            } else {
              Message.error('您还没有绑定店铺，请先绑定店铺');
              next("/profile/index");
              NProgress.done();
            }

            _context.next = 50;
            break;

          case 29:
            _context.prev = 29;
            _context.next = 32;
            return store.dispatch('user/getInfo');

          case 32:
            _userInfo = _context.sent;
            _context.next = 35;
            return store.dispatch('country/getCountries');

          case 35:
            _context.next = 37;
            return store.dispatch('logisticsType/getLogisticsTypes');

          case 37:
            _context.next = 39;
            return store.dispatch('logisticsType/getTemplateList');

          case 39:
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
            next();
            _context.next = 50;
            break;

          case 43:
            _context.prev = 43;
            _context.t1 = _context["catch"](29);
            _context.next = 47;
            return store.dispatch('user/resetToken');

          case 47:
            Message.error(_context.t1 || 'Has Error');
            next("/login?redirect=".concat(to.path));
            NProgress.done();

          case 50:
            _context.next = 53;
            break;

          case 52:
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));
              NProgress.done();
            }

          case 53:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[12, 18], [29, 43]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});